import React from 'react';
import { Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import '../public/css/Home.css';

const Home = () => (
	<Link className="text" to="/Map">
		<Segment className="home" style={{ padding: 0, margin: 0 }} basic textAlign="center">
			<div className="home-bg">
				<div className="home-bg-img" />
			</div>

			<div className="home-enter-btn">
				<div className="text">The Persian Tadhkira Project</div>
			</div>
		</Segment>
	</Link>
);

export default Home;
